import { useEffect, useState } from "react";
import { http, rp, rpShort, nf } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, Stat, KatBadge } from "@/components/Ui";
import AiInsight from "@/components/AiInsight";
import ExportButtons from "@/components/ExportButtons";

const BRANCHES = ["Surabaya", "Jakarta", "Medan", "Semarang", "Bandung", "Palembang", "Pekanbaru", "Makassar", "Banjarmasin", "Balikpapan"];

export default function ReportStock() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [periode, setPeriode] = useState("");

  useEffect(() => {
    http.get("/reports/stock", { params: periode ? { periode } : {} })
      .then((r) => setD(r.data)).catch(() => setD({ rows: [], total_qty: 0, total_nominal: 0, periode_list: [] }));
  }, [periode]);

  if (!d) return <div className="p-8 mono text-sm">Memuat laporan…</div>;
  const cols = user.role === "cabang" ? [user.branch] : BRANCHES;
  const showCost = user.role === "keuangan" || user.role === "purchasing";

  return (
    <div data-testid="report-stock-page">
      <PageHeader subtitle="Laporan" title="Laporan Stock Cabang & Nasional" testId="report-stock-header">
        <select data-testid="report-stock-periode-filter" value={periode} onChange={(e) => setPeriode(e.target.value)}
          className="h-10 px-3 border border-neutral-300 bg-white text-sm outline-none focus:ring-2 focus:ring-[#4338CA]">
          <option value="">Semua Periode</option>
          {(d.periode_list || []).map((p) => <option key={p} value={p}>{p}</option>)}
        </select>
        <ExportButtons kind="stock" params={periode ? { periode } : {}} testId="export-stock" />
      </PageHeader>

      <div className="p-6 sm:p-8 space-y-4">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
          <Stat testId="report-stock-total-qty" label="Total Qty Semua Produk" value={nf(d.total_qty)} />
          <Stat testId="report-stock-total-nominal" label="Total Nominal (Harga Jual A)" value={rpShort(d.total_nominal)} sub={rp(d.total_nominal)} accent="#4338CA" />
          <Stat testId="report-stock-count" label="Jumlah Baris Produk" value={nf(d.rows.length)} />
        </div>

        <div className="erp-panel overflow-auto max-h-[70vh]" data-testid="report-stock-table-wrap">
          <table className="erp-table">
            <thead>
              <tr>
                <th>Kode Stock</th><th>Deskripsi Produk</th><th>Type</th><th>Spesifikasi</th>
                <th>Kategori</th><th>Periode</th>
                {cols.map((b) => <th key={b} className="num">{b}</th>)}
                <th className="num">Total Qty</th><th className="num">Harga Jual A</th>
                {showCost && <th className="num">HPP</th>}
                <th className="num">Nominal</th>
              </tr>
            </thead>
            <tbody>
              {d.rows.map((r, i) => (
                <tr key={i} data-testid={`report-stock-row-${r.kode_stock}`}>
                  <td className="mono font-medium">{r.kode_stock}</td>
                  <td className="max-w-[200px] truncate">{r.deskripsi_produk}</td>
                  <td>{r.type_produk}</td>
                  <td className="max-w-[220px] truncate">{r.spesifikasi_produk}</td>
                  <td><KatBadge value={r.kategori_pemasaran} /></td>
                  <td>{r.periode}</td>
                  {cols.map((b) => <td key={b} className="num">{nf(r.detail?.[b] || 0)}</td>)}
                  <td className="num font-semibold">{nf(r.qty)}</td>
                  <td className="num">{rp(r.harga_jual_a)}</td>
                  {showCost && <td className="num">{rp(r.hpp_idr || 0)}</td>}
                  <td className="num font-semibold">{rp(r.nominal)}</td>
                </tr>
              ))}
              {d.rows.length === 0 && (
                <tr><td colSpan={20} className="text-center text-neutral-500 py-6">Belum ada data stock</td></tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={6}>TOTAL</td>
                {cols.map((b) => (
                  <td key={b} className="num">{nf(d.rows.reduce((a, r) => a + (r.detail?.[b] || 0), 0))}</td>
                ))}
                <td className="num">{nf(d.total_qty)}</td>
                <td className="num">—</td>
                {showCost && <td className="num">—</td>}
                <td className="num">{rp(d.total_nominal)}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        <AiInsight scope="stock" />
      </div>
    </div>
  );
}
